import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { lazy, Suspense } from 'react';
import { BrowserRouter, } from "react-router-dom";
import { HexColor } from "@/types/Color";
import Loading from "@/ui/Loading/Loading";
import { LoadingType } from "@/types/Loading";
import { useAuth, useAutoLogin } from "@/hooks/auth";
var Header = lazy(function () { return import("@/modules/Header/Header"); });
var AppRoutes = lazy(function () { return import("@/AppRoutes"); });
var App = function () {
    useAuth();
    useAutoLogin();
    return (_jsx(BrowserRouter, { children: _jsx("div", { className: "min-h-screen min-w-screen flex items-center flex-col", children: _jsxs(Suspense, { fallback: _jsx(Loading, { type: LoadingType.Large, color: HexColor.black }), children: [_jsx(Header, {}), _jsx(AppRoutes, {})] }) }) }));
};
export default App;
